import { COMPONENT_VALUE_TYPES as types, TWO_COLUMN_TEXT_LAYOUTS } from 'shared/constants';

const propsSchema = [
  {
    key: 'section_tag',
    label: 'Section Tag',
    type: types.TEXT
  },
  {
    key: 'intro',
    label: 'Intro Section',
    type: types.OBJECT,
    option: false,
    children: [
      {
        key: 'bgimage',
        label: 'Background Image',
        type: types.TEXT
      },
      {
        key: 'pageSectionHeader',
        label: 'Page Section Header',
        type: types.TEXT
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'introText',
        label: 'Intro Text',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'features',
    label: 'Features',
    type: types.OBJECT,
    option: false,
    children: [
      {
        key: 'bgimage',
        label: 'Background Image',
        type: types.TEXT
      },
      {
        key: 'featureList',
        label: 'Feature List',
        type: types.ARRAY,
        children: [{
          key: 'title',
          label: 'Title',
          type: types.TEXT
        }]
      },
    ]
  },
  {
    key: 'additionalScreens',
    label: 'Additional Screens',
    type: types.ARRAY,
    option: false,
    children: [
      {
        key: 'bgimage',
        label: 'Background Image',
        type: types.TEXT
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT
      },
      {
        key: 'textLayout',
        label: 'Text Layout',
        type: types.ENUM,
        options: TWO_COLUMN_TEXT_LAYOUTS
      },
      {
        key: 'hide_on_mobile',
        label: 'Hide Copy Block on Mobile',
        type: types.BOOLEAN
      }
    ]
  }
];

const defaultProps = {
  section_tag: 'performance',
  intro: {
    bgimage: 'https://genesis-cdn.ff.com/product/03_performance/01.jpg',
    pageSectionHeader: 'FF 91 Performance',
    title: 'A Cleaner, More Electrifying Future',
    introText: 'Committed to breathtaking power that also allows us to breath more freely, our engineers are pushing the limits of electric performance and range. Designed to be highly modular, our Variable Platform Architecture (VPA) securely houses the battery, powertrain and our first patent: the FF Echelon Inverter.'
  },
  features: {
    bgimage: 'https://genesis-cdn.ff.com/product/03_performance/02.jpg',
    featureList: [
      { title: '3 Electric Motors' },
      { title: '0-60 in 2.39 secs' },
      { title: '1050 Horsepower' },
      { title: 'Dynamic Vehicle Control' }
    ]
  },
  additionalScreens: [
    {
      bgimage: 'https://genesis-cdn.ff.com/product/03_performance/03.jpg',
      title: '300+ Miles per Charge',
      description: 'Our lithium-ion battery cells achieve the world’s highest energy density – nearly double that of a production automotive battery. This not only represents a significant step forward in battery technology, it’s a tremendous increase in range, well in excess of 300 miles on a single charge.',
      textLayout: 'LEFT',
      hide_on_mobile: true
    }
  ]
};

export default {
  title: 'Onion Peel',
  id: 'OnionPeel',
  propsSchema,
  defaultProps
};
